import styled from 'styled-components';
import { StatusCell } from 'ui/tableCell/variants/StatusCell';

const Container = styled.div`
  min-width: 200px;
`;

const DT = styled.dt`
  display: inline;
  font-weight: 600;
`;

const DD = styled.dd`
  font-family: monospace;
  word-break: break-all;
  white-space: pre-wrap;
  font-size: 12px;
  padding: 10px 0;
`;

type Props = {
  recordName: string;
  recordType: string;
  recordValue: string;
  hasEntry: boolean;
};

export const DKIM = ({ recordName, recordType, recordValue, hasEntry }: Props) => (
  <Container data-test="sending-domains-dkim-record">
    <StatusCell
      negativeLabel="Record is invalid"
      positiveLabel="Record is valid"
      showPositiveState={hasEntry}
    />
    <dl>
      <DT>Record name</DT>
      <DD>{recordName}</DD>
      <DT>Record type</DT>
      <DD>{recordType}</DD>
      <DT>Record value</DT>
      <DD>{recordValue}</DD>
    </dl>
  </Container>
);
